import {environment} from '@src/environments/environment';

export function getQuickEntryExtensionId(): string {
  return typeof navigator !== 'undefined' && navigator.userAgent.includes('Edg')
    ? environment.edgeExtensionId
    : environment.chromeExtensionId;
}
